

  <form *ngIf="isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group">
          <label for="Suplement">
            <span class="mandatory">*</span>
            Suplemento
          </label>
          <select class="custom-select" [(ngModel)]="item.suplement" name="suplement"
                  #suplement="ngModel"
                  (ngModelChange)="suplementChanged()"
                  [clearRelated]="{model : this.item , propsToReset : ['numberOfSemesters']}"
                  [dropdownTitle]="{value : item.suplement }" nullableSelect required>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of suplements" [value]="domain.value">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="suplement"></validation-message>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="RenumerationType">
            <span *ngIf="item.suplement === 'OUTR'" class="mandatory">*</span>
            Tipo de remuneração
          </label>
          <select class="custom-select" [(ngModel)]="item.renumerationType" name="renumerationType" currency
                  #renumerationType="ngModel"
                  (ngModelChange)="renumerationTypeChanged()"
                  [disabled]="item.suplement !== 'OUTR'"
                  [clearRelated]="{model : this.item , propsToReset : ['numberOfSemesters']}" [dropdownTitle]="{value : item.renumerationType }" nullableSelect required>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of getRenumerationTypes()" [value]="domain.value">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="renumerationType"></validation-message>
        </div>
      </div>
    </div>

    <div *ngIf="item.suplement === 'OUTR'" class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="AppliableSuplement">
            <span class="mandatory">*</span>
            Suplemento aplicável
          </label>

          <input class="form-control" type="text" maxlength="60"
                 placeholder="Indique o suplemento"
                 [(ngModel)]="item.appliableSuplement" name="appliableSuplement" #appliableSuplement="ngModel" required>
          <validation-message [control]="appliableSuplement"></validation-message>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label for="Legislation">
            <span class="mandatory">*</span>
            Legislação
          </label>
          <input class="form-control" type="text" maxlength="60"
                 placeholder="Indique a legislação"
                 [(ngModel)]="item.legislation" name="legislation" #legislation="ngModel" required>
          <validation-message [control]="legislation"></validation-message>
        </div>
      </div>
    </div>

    <div *ngIf="item.renumerationType === 'A' || item.renumerationType === 'O' || (item.renumerationType === 'B' && parent['cardConfiguration']['cardCode'] === 'RemunerationsCurrentMonthly')">
      <div class="row">
        <div *ngIf="item.renumerationType === 'A' || item.renumerationType === 'O' || item.renumerationType === 'B' && parent['cardConfiguration']['cardCode'] !== 'RemunerationsCurrentMonthly'" class="col-sm-3">
          <div class="form-group-top">
            <label for="Start">
              <span class="mandatory">*</span>{{'RemunerationOtherEditTable.Start' | translate}}
              <!--<span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsLastUntilCutoff.StartDate' | translate}}" *ngIf="!isParentCurrentMonthly"></span>
              <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.StartDate' | translate}}" *ngIf="isParentCurrentMonthly"></span>-->
            </label>

            <div class="position-relative input-group">
              <input #dpStartDate="bsDatepicker" bsDatepicker
                     type="text"
                     autocomplete="off"
                     placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                     class="form-control DatepickerCustomClasse"
                     [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                     [minDate]="minDate"
                     [maxDate]="maxDate"
                     maxlength="10"
                     [(ngModel)]="item.startDate" name="startDate" #startDate="ngModel" required externalValidation="remunerationsList" [tableIndex]="editIndex" disabled
                     (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDate)" />
              <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
                <span class="input-group-text" id="basic-addon2">
                  <i class="icon-calendar"></i>
                </span>
              </div>
              <validation-message [control]="startDate"></validation-message>
            </div>
          </div>
        </div>

        <div *ngIf="item.renumerationType === 'A' || item.renumerationType === 'O'" class="col-sm-3">
          <div class="form-group-top">
            <label for="RemunerationValue"><span class="mandatory">*</span>Remuneração Mensal</label>
            <div class="position-relative">
              <input class="form-control input-left" type="text" currency
                     placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                     [(ngModel)]="item.remunerationValue" name="remunerationValue" #remunerationValue="ngModel" required maxValue="99999999,99" messageFieldType="currency">
              <span class="input-icon-span-left">€</span>
              <validation-message [control]="remunerationValue"></validation-message>
            </div>
          </div>
        </div>

        <div *ngIf="item.renumerationType === 'O'" class="col-sm-2">
          <div class="form-group-top">
            <label for="NumberOfSemesters" [class.disabled]="item.renumerationType !== 'O'">
              <span class="mandatory">*</span>
              Nº de semestres
            </label>
            <input class="form-control" type="number" numeric="2" [(ngModel)]="item.numberOfSemesters" name="numberOfSemesters" #numberOfSemesters="ngModel" maxlength="2" min="1" placeholder="00" [disabled]="item.renumerationType !== 'O'" required>
            <validation-message *ngIf="item.renumerationType === 'O'" [control]="numberOfSemesters"></validation-message>
          </div>
        </div>

        <div *ngIf="item.renumerationType === 'O'" class="col-sm-5">
          <div class="form-group">
            <label for="IncludesPercentage">
              <span class="mandatory">*</span>
              Inclui a percentagem de 40% com os valores?
            </label>

            <div class="btn-group btn-group-toggle">
              <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.includesPercentage" [radioLabel]="includesPercentage">
                <input type="radio" [(ngModel)]="item.includesPercentage" name="includesPercentage" #includesPercentage="ngModel" [value]="domain.value" required>
                {{domain.description}}
              </label>
              <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="item.renumerationType === 'B' && isParentCurrentMonthly">
      <h3 style="border-bottom: '2px solid #3391FF;'; padding: 0.75rem">Data/Remuneração</h3>
      <div class="row">
        <div *ngFor="let month of last24Months; let i = index;" class="col-sm-3">
          <div class="form-group">
            <label for="Month{{i}}">
              <span class="mandatory">*</span>
              {{month}}
            </label>
            <div class="position-relative">
              <input class="form-control input-left" type="text" currency
                     (input)="anyMonthlyRemun()"
                     placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                     [(ngModel)]="item['month'+i]" name="month{{i}}" #monthValueMonthly="ngModel" maxValue="99999999,99" messageFieldType="currency" required>
              <span class="input-icon-span-left">€</span>
              <validation-message [control]="monthValueMonthly"></validation-message>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="item.renumerationType === 'B' && !isParentCurrentMonthly">
      <h3 style="border-bottom: '2px solid #3391FF;'; padding: 0.75rem">Data/Remuneração</h3>
      <div class="row">
        <div *ngFor="let month of last24MonthsBefore2005End; let i = index;" class="col-sm-3">
          <div class="form-group">
            <label for="Month{{i}}">
              <span class="mandatory">*</span>
              {{month}}
            </label>
            <div class="position-relative">
              <input class="form-control input-left" type="text" currency
                     (input)="anyMonthlyRemun()"
                     placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                     [(ngModel)]="item['month'+i]" name="month{{i}}" #monthValueNonMonthly="ngModel" maxValue="99999999,99" messageFieldType="currency" required>
              <span class="input-icon-span-left">€</span>
              <validation-message [control]="monthValueNonMonthly"></validation-message>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span *ngIf="!tableItemEditForm.valid" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>
    <span *ngIf="item.renumerationType === 'B' && isTypeBRemunNonZero !== true" class="text-danger validation_error_all" style="font-weight: 600; font-size: 13px;">{{'RemunerationOtherEditTable.BTypeRemunerationInvalid' | translate}}</span>
    
  </form>

<form *ngIf="!isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="Designation"><span class="mandatory">*</span>{{'RemunerationOtherEditTable.Designation' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.RemunerationOtherEditTable.Designation' | translate}}"
               [(ngModel)]="item.designation" name="designation" #designation="ngModel" maxlength="60" required>
        <validation-message [control]="designation"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="Start">
          <span class="mandatory">*</span>{{'RemunerationOtherEditTable.Start' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsLastUntilCutoff.StartDate' | translate}}" *ngIf="!isParentCurrentMonthly"></span>
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.StartDate' | translate}}" *ngIf="isParentCurrentMonthly"></span>
        </label>

        <div class="input-group">
          <input #dpStartDate="bsDatepicker" bsDatepicker
                 type="text"
                 autocomplete="off"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [minDate]="minDate"
                 [maxDate]="maxDate"
                 maxlength="10"
                 [(ngModel)]="item.startDate" name="startDate" #startDate="ngModel" required externalValidation="remunerationsList" [tableIndex]="editIndex"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="startDate"></validation-message>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="RemunerationValue"><span class="mandatory">*</span>{{'RemunerationOtherEditTable.RemunerationValue' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="item.remunerationValue" name="remunerationValue" #remunerationValue="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="remunerationValue"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="!tableItemEditForm.valid" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>

</form>

<div class="d-flex justify-content-between mt-4 mb-2">
  <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)"><span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span></button>
  <button type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)"><span class="icon-check"></span><span>Aplicar</span></button>
</div>

